<template>
    <div class="app-main">
        <el-scrollbar wrap-class="scrollbar-wrapper">
            <div class="content-box">
                <transition name="fade-transform" mode="out-in">
                    <keep-alive :include="cachedViews">
                        <router-view :key="key"/>
                    </keep-alive>
                </transition>
            </div>
        </el-scrollbar>
    </div>
</template>

<script>
    export default {
        name: 'AppMain',
        computed: {
            cachedViews() {
                return this.$store.state.tagsView.cachedViews
            },
            key() {
                return this.$route.fullPath
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/styles/variables.scss";

    $fixHeaderHeight: 0px;
    .app-main {
        height: 100%;
        width: 100%;
        position: relative;
        .content-box {
            height: calc(100vh - #{$fixHeaderHeight});
        }
        /deep/ .el-scrollbar {
            height: 100%;
            .scrollbar-wrapper {
                overflow-x: hidden!important;
                overflow-y: scroll!important;
            }
        }
    }

    .hasTopHeader {
        .app-main {
            height: calc(100vh - #{$headerHeight});
            .content-box {
                height: calc(100vh - #{$headerHeight} - #{$fixHeaderHeight});
            }
        }
    }

    .fixed-header + .app-main {
        padding-top: $fixHeaderHeight;
    }

    .hasTagsView {
        .app-main {
            .content-box {
                height: calc(100vh - #{$fixHeaderHeight} - #{$tagViewHeight});
            }
        }

        .fixed-header + .app-main {
            padding-top: calc(#{$fixHeaderHeight} + #{$tagViewHeight});
        }
    }

    .hasTopHeader {
        .hasTagsView {
            .app-main {
                .content-box {
                    height: calc(100vh - #{$headerHeight} - #{$fixHeaderHeight} - #{$tagViewHeight});
                }
            }
        }
    }
</style>

